import { intersect, literal, number, partial, struct, union } from 'io-ts/Decoder';

export const EachMeasurement = struct({
	measurementType: union(literal('each')),
	quantity: number, //count
});

export const LengthMeasurement = struct({
	measurementType: literal('length'),
	length: number, //float
});

export const AreaMeasurement = intersect(
	struct({
		measurementType: literal('area'),
		area: number, //float
	})
)(
	partial({
		length: number, //float
	})
);

export const InclinedArea = intersect(
	struct({
		measurementType: literal('inclined_area'),
		area: number, // float
		pitch: number, // float
		quantity: number, // int
	})
)(
	partial({
		length: number, // float
	})
);

export const LengthAndHeightMeasurement = struct({
	measurementType: literal('length_and_height'),
	length: number,
	height: number,
	//area: number,
	//quantity: number,
});

export const AreaAndHeightMeasurement = intersect(
	struct({
		measurementType: literal('area_and_height'),
		area: number,
		height: number,
		//volume: number,
		//quantity: number,
	})
)(
	partial({
		//length: number,
	})
);

export const MeasurementItem = union(
	EachMeasurement,
	LengthMeasurement,
	LengthAndHeightMeasurement,
	AreaMeasurement,
	AreaAndHeightMeasurement,
	InclinedArea
);
